import CompanyServices from "@/services/CompanyServices.js";
import InvoiceServices from "@/services/InvoiceServices.js";

export default {
  getCompanyDetails: CompanyServices.getDetails,
  getInvoiceDetails: InvoiceServices.getDetails,
}